/**
 * Created by xuxin06@meituan.com on 2017/7/24.
 */
let notMenu = true;
export default [{
    name: 'misCreateTicket',
    path: '/mis/ticket/product/item/:id?',
    component: require('views/ticket/product/item/Main.vue'),
    meta: {
        isMis: true,
        notMenu
    }
},
{
    name: 'bizCreateTicket',
    path: 'product/item/:id?',
    component: require('views/ticket/product/item/Main.vue'),
    meta: {
        notMenu
    }
},
{
    name: 'misCreateTuanTicket',
    path: '/mis/ticket/tuan/item/:id?',
    component: require('views/ticket/product/tuan/Main.vue'),
    meta: {
        isMis: true,
        notMenu
    }
},
{
    name: 'phoneVerify',
    path: 'phoneVerify',
    redirect: { name: 'app' },
    meta: {
        title: '手机验证',
        notMenu
    },
    component: require('views/ticket/verify/phone/Main.vue'),
    children: [{
        name: 'phone',
        path: 'phone',
        component: require('views/ticket/verify/phone/pages/phoneVerify.vue'),
    }, {
        name: 'app',
        path: 'app',
        component: require('views/ticket/verify/phone/pages/appVerify.vue')
    }]
},
{
    name: 'verifyHistory',
    path: 'verifyHistory',
    redirect: { name: 'singleProgram' },
    component: require('views/ticket/verify/history/Main.vue'),
    meta: {
        title: '验证历史',
        requiresAuth: true,
        isOpened: null,
        notMenu
    },
    children: [{
        name: 'singleProgram',
        path: 'singleProgram',
        component: require('views/ticket/verify/history/pages/singleProgramConsumption.vue')
    },
    {
        name: 'allProgram',
        path: 'allProgram',
        component: require('views/ticket/verify/history/pages/allProgramConsumption.vue')
    }
    ]
}, {
    name: 'programData',
    path: 'views/dataCenter/programData',
    component: require('views/dataCenter/programData.vue'),
    meta: {
        notMenu
    }
},
{
    name: 'operationData',
    path: 'views/dataCenter/operationData',
    component: require('views/dataCenter/operationData.vue'),
    meta: {
        notMenu
    }
}
]


// WEBPACK FOOTER //
// ./src/router/router.ticket.js